import { Button, Tooltip } from 'shared-ui';

import { ReactComponent as UnarchiveIcon } from 'assets/icons/bring-back.svg';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';

import { UnarchiveMultiOwnersProps } from './UnarchiveMultiOwners.types';

export const UnarchiveMultiOwners = ({
  checkedOwners,
  isModalOpen,
  onSubmit,
  isLoading,
  onModalClose,
  onModalOpen,
}: UnarchiveMultiOwnersProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();

  const isDisabled = !perms?.[Functionality.KARTY_POSIADACZE]?.edit;

  return (
    <>
      <Tooltip title={formatMessage({ id: AppMessages['common.noPermissions'] })} disableHoverListener={!isDisabled}>
        <Button
          variant="outlined"
          color="primary"
          size="medium"
          startIcon={<UnarchiveIcon />}
          onClick={onModalOpen}
          disabled={isDisabled}
        >
          {formatMessage({ id: AppMessages['cards.multiAction.unarchive.button'] })}
        </Button>
      </Tooltip>

      <ActionModal
        header={formatMessage({ id: AppMessages['owners.multiAction.unarchive.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['owners.multiAction.unarchive.submitButton'] })}
      >
        <ActionModal.Subtitle>
          {formatMessage({ id: AppMessages['owners.multiAction.unarchive.subtitle'] })} {checkedOwners.length}
        </ActionModal.Subtitle>

        <ActionModal.Text>{formatMessage({ id: AppMessages['owners.multiAction.unarchive.text'] })}</ActionModal.Text>
      </ActionModal>
    </>
  );
};
